"use client";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from "react";

import { cn } from "../utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = forwardRef<
	ElementRef<typeof TooltipPrimitive.Content>,
	ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, side = "bottom", ...props }, ref) => (
	<TooltipPrimitive.Content
		ref={ref}
		sideOffset={sideOffset}
		side={side}
		className={cn(
			"z-popover",
			"overflow-hidden",
			"rounded-md",
			"border",
			"bg-palette-gray-12",
			"text-palette-gray-1",
			"px-3",
			"py-1.5",
			"text-sm",
			"shadow-md",
			"animate-in",
			"fade-in-0",
			"zoom-in-95",
			"data-[state=closed]:animate-out",
			"data-[state=closed]:fade-out-0",
			"data-[state=closed]:zoom-out-95",
			"data-[side=bottom]:slide-in-from-top-2",
			"data-[side=left]:slide-in-from-right-2",
			"data-[side=right]:slide-in-from-left-2",
			"data-[side=top]:slide-in-from-bottom-2",
			"origin-[--radix-tooltip-content-transform-origin]",
			className
		)}
		{...props}
	/>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const TooltipArrow = TooltipPrimitive.Arrow;

const TooltipPortal = TooltipPrimitive.Portal;

export { Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger };

export const BasicTooltip = (props: ComponentPropsWithoutRef<typeof Tooltip>) => (
	<TooltipProvider>
		<Tooltip {...props} />
	</TooltipProvider>
);
